module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("vanguard-contact-form " + (_vm.isAspspEligible ? 'vanguard-aspsp-eligible' : 'vanguard-aspsp-no-eligible'))
  }, [(!_vm.isFormLoading && _vm.showPalyanceBanner) ? _c('div', {
    staticClass: "alert alert-primary"
  }, [_c('p', {
    staticClass: "text-center m-0"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('form.dataLinkedTo')) + " "), _c('strong', [_vm._v(_vm._s(_vm.aspspEmail))]), _vm._v(" " + _vm._s(_vm.$t('form.haveBeenUsedToFillTheForm')) + "\n      " + _vm._s(_vm.$t('form.youWillBeDeliveredAt')) + " "), _c('strong', [_vm._v(_vm._s(_vm.aspspFullAddress))])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('small', [_c('a', {
    staticClass: "text-muted",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editAspspPrefillData.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('form.editMyAddress')))])])])]) : _vm._e(), _vm._v(" "), (_vm.isFormLoading) ? _c('div', {
    staticClass: "vanguard-spinner-container"
  }, [_c('div', {
    staticClass: "spinner-border",
    attrs: {
      "role": "status"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t("all.loading")))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFormLoading && !_vm.showPalyanceBanner),
      expression: "!isFormLoading && !showPalyanceBanner"
    }],
    staticClass: "vanguard-contact-information"
  }, [_c('div', {
    staticClass: "vanguard-billing-form"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingEmail"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.email')) + " "), _c('span', {
    staticClass: "vanguard-required-star"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingEmail),
      expression: "billingEmail"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email|min:6'),
      expression: "'required|email|min:6'"
    }],
    ref: "billingEmail",
    class: {
      'form-control': true, 'vanguard-contact-form-field': true, error: _vm.errors.has('billingEmail')
    },
    attrs: {
      "type": "email",
      "id": "billingEmail",
      "data-vv-name": "billingEmail",
      "disabled": _vm.isAspspEligible
    },
    domProps: {
      "value": (_vm.billingEmail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.billingEmail = $event.target.value
      }, function($event) {
        return _vm.userInput('billingEmail')
      }]
    }
  }), _vm._v(" "), (_vm.isAspspEligible) ? _c('div', {
    staticClass: "text-right w-100"
  }, [_c('small', [_c('a', {
    staticClass: "text-muted",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeWalletIdFromURLAndRedirect.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('form.thisIsNotMyEmail')))])])]) : _vm._e(), _vm._v(" "), (_vm.errors.has('billingEmail')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingEmail')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingEmailConfirm"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.emailConfirm')) + " "), _c('span', {
    staticClass: "vanguard-required-star"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingEmailConfirm),
      expression: "billingEmailConfirm"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:billingEmail'),
      expression: "'required|confirmed:billingEmail'"
    }],
    class: {
      'form-control': true, 'vanguard-contact-form-field': true, error: _vm.errors.has('billingEmailConfirm')
    },
    attrs: {
      "type": "email",
      "id": "billingEmailConfirm",
      "data-vv-name": "billingEmailConfirm",
      "data-vv-as": "billingEmail",
      "disabled": _vm.isAspspEligible
    },
    domProps: {
      "value": (_vm.billingEmailConfirm)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.billingEmailConfirm = $event.target.value
      }, function($event) {
        return _vm.userInput('billingEmailConfirm')
      }]
    }
  }), _vm._v(" "), (_vm.errors.has('billingEmailConfirm')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingEmailConfirm')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group form-group-gender"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingGender"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.gender')))]), _vm._v(" "), _c('div', {
    staticClass: "pt-1"
  }, [_vm._l((_vm.genders), function(gender) {
    return [_c('div', {
      key: 'billing-gender-' + gender.code,
      staticClass: "form-check form-check-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.billingGender),
        expression: "billingGender"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "radio",
        "name": "billing-gender",
        "id": 'billing-gender-' + gender.code
      },
      domProps: {
        "value": gender.code,
        "checked": _vm._q(_vm.billingGender, gender.code)
      },
      on: {
        "change": function($event) {
          _vm.billingGender = gender.code
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-check-label",
      attrs: {
        "for": 'billing-gender-' + gender.code
      }
    }, [_vm._v(_vm._s(gender.label))])])]
  })], 2), _vm._v(" "), (_vm.errors.has('billingGender')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingGender')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingFirstName"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.firstName')) + " "), _c('span', {
    staticClass: "vanguard-required-star"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingFirstName),
      expression: "billingFirstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2|max:40'),
      expression: "'required|min:2|max:40'"
    }],
    class: {
      'form-control': true, 'vanguard-contact-form-field': true, error: _vm.errors.has('billingFirstName')
    },
    attrs: {
      "type": "text",
      "id": "billingFirstName",
      "data-vv-name": "billingFirstName"
    },
    domProps: {
      "value": (_vm.billingFirstName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.billingFirstName = $event.target.value
      }, function($event) {
        return _vm.userInput('billingFirstName')
      }]
    }
  }), _vm._v(" "), (_vm.errors.has('billingFirstName')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingFirstName')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingLastName"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.lastName')) + " "), _c('span', {
    staticClass: "vanguard-required-star"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingLastName),
      expression: "billingLastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2|max:80'),
      expression: "'required|min:2|max:80'"
    }],
    class: {
      'form-control': true, 'vanguard-contact-form-field': true, error: _vm.errors.has('billingLastName')
    },
    attrs: {
      "type": "text",
      "id": "billingLastName",
      "data-vv-name": "billingLastName"
    },
    domProps: {
      "value": (_vm.billingLastName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.billingLastName = $event.target.value
      }, function($event) {
        return _vm.userInput('billingLastName')
      }]
    }
  }), _vm._v(" "), (_vm.errors.has('billingLastName')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingLastName')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingPhoneNumber"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.phone')) + "  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingPhoneNumber),
      expression: "billingPhoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        max: 20,
        regex: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/i
      }),
      expression: "{max:20, regex: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$/i}"
    }],
    class: {
      'form-control': true, 'vanguard-contact-form-field': true, error: _vm.errors.has('billingPhoneNumber')
    },
    attrs: {
      "type": "text",
      "id": "billingPhoneNumber",
      "data-vv-name": "billingPhoneNumber"
    },
    domProps: {
      "value": (_vm.billingPhoneNumber)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.billingPhoneNumber = $event.target.value
      }, function($event) {
        return _vm.userInput('billingPhoneNumber')
      }]
    }
  }), _vm._v(" "), (_vm.errors.has('billingPhoneNumber')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingPhoneNumber')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingStreet3"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.normalizedStreet3')) + " "), _c('span', {
    staticClass: "vanguard-required-star"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingStreet3),
      expression: "billingStreet3"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:96'),
      expression: "'required|min:6|max:96'"
    }],
    class: {
      'form-control': true, 'vanguard-contact-form-field': true, error: _vm.errors.has('billingStreet3')
    },
    attrs: {
      "type": "text",
      "id": "billingStreet3",
      "data-vv-name": "billingStreet3"
    },
    domProps: {
      "value": (_vm.billingStreet3)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.billingStreet3 = $event.target.value
      }, function($event) {
        return _vm.updateBillingStreet3()
      }]
    }
  }), _vm._v(" "), (_vm.errors.has('billingStreet3')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingStreet3')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingStreet1"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.normalizedStreet1')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingStreet1),
      expression: "billingStreet1"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:96'),
      expression: "'max:96'"
    }],
    class: {
      'form-control': true, 'vanguard-contact-form-field': true, error: _vm.errors.has('billingStreet1')
    },
    attrs: {
      "type": "text",
      "id": "billingStreet1",
      "data-vv-name": "billingStreet1"
    },
    domProps: {
      "value": (_vm.billingStreet1)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.billingStreet1 = $event.target.value
      }, function($event) {
        return _vm.userInput('billingStreet1')
      }]
    }
  }), _vm._v(" "), (_vm.errors.has('billingStreet1')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingStreet1')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingStreet2"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.normalizedStreet2')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingStreet2),
      expression: "billingStreet2"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:96'),
      expression: "'max:96'"
    }],
    class: {
      'form-control': true, 'vanguard-contact-form-field': true, error: _vm.errors.has('billingStreet2')
    },
    attrs: {
      "type": "text",
      "id": "billingStreet2",
      "data-vv-name": "billingStreet2"
    },
    domProps: {
      "value": (_vm.billingStreet2)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.billingStreet2 = $event.target.value
      }, function($event) {
        return _vm.userInput('billingStreet2')
      }]
    }
  }), _vm._v(" "), (_vm.errors.has('billingStreet2')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingStreet2')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingStreet4"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.normalizedStreet4')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingStreet4),
      expression: "billingStreet4"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:96'),
      expression: "'max:96'"
    }],
    class: {
      'form-control': true, 'vanguard-contact-form-field': true, error: _vm.errors.has('billingStreet4')
    },
    attrs: {
      "type": "text",
      "id": "billingStreet4",
      "data-vv-name": "billingStreet4"
    },
    domProps: {
      "value": (_vm.billingStreet4)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.billingStreet4 = $event.target.value
      }, function($event) {
        return _vm.updateBillingStreet4()
      }]
    }
  }), _vm._v(" "), (_vm.errors.has('billingStreet4')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingStreet4')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingZipCode"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.zipCode')) + " "), _c('span', {
    staticClass: "vanguard-required-star"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingZipCode),
      expression: "billingZipCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3|max:10'),
      expression: "'required|min:3|max:10'"
    }],
    class: {
      'form-control': true, 'vanguard-contact-form-field': true, error: _vm.errors.has('billingZipCode')
    },
    attrs: {
      "type": "text",
      "id": "billingZipCode",
      "data-vv-name": "billingZipCode"
    },
    domProps: {
      "value": (_vm.billingZipCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.billingZipCode = $event.target.value
      }, function($event) {
        return _vm.userInput('billingZipCode')
      }]
    }
  }), _vm._v(" "), (_vm.errors.has('billingZipCode')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingZipCode')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingCity"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.city')) + " "), _c('span', {
    staticClass: "vanguard-required-star"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingCity),
      expression: "billingCity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:40'),
      expression: "'required|max:40'"
    }],
    class: {
      'form-control': true, 'vanguard-contact-form-field': true, error: _vm.errors.has('billingCity')
    },
    attrs: {
      "type": "text",
      "id": "billingCity",
      "data-vv-name": "billingCity"
    },
    domProps: {
      "value": (_vm.billingCity)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.billingCity = $event.target.value
      }, function($event) {
        return _vm.userInput('billingCity')
      }]
    }
  }), _vm._v(" "), (_vm.errors.has('billingCity')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingCity')) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row form-group"
  }, [_c('label', {
    staticClass: "vanguard-contact-form-label",
    attrs: {
      "for": "billingCountry"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.country')) + " "), _c('span', {
    staticClass: "vanguard-required-star"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingCountry),
      expression: "billingCountry"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:80'),
      expression: "'required|max:80'"
    }],
    staticClass: "form-control vanguard-contact-form-field",
    class: {
      'form-control': true, 'vanguard-contact-form-field': true, error: _vm.errors.has('billingCountry')
    },
    attrs: {
      "id": "billingCountry",
      "data-vv-name": "billingCountry"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.billingCountry = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.userInput('billingCountry')
      }]
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      key: 'billing-' + country.code,
      domProps: {
        "value": country.code
      }
    }, [_vm._v("\n                " + _vm._s(country.label) + "\n              ")])
  }), 0), _vm._v(" "), (_vm.errors.has('billingCountry')) ? _c('div', {
    staticClass: "vanguard-form-error"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('billingCountry')) + "\n            ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "vanguard-optins-container"
  }, [_c('div', {
    staticClass: "row form-group form-check vanguard-cgu"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localConditionsApproved),
      expression: "localConditionsApproved"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "conditionsApproved",
      "data-vv-name": "localConditionsApproved"
    },
    domProps: {
      "checked": Array.isArray(_vm.localConditionsApproved) ? _vm._i(_vm.localConditionsApproved, null) > -1 : (_vm.localConditionsApproved)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localConditionsApproved,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.localConditionsApproved = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.localConditionsApproved = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.localConditionsApproved = $$c
        }
      }
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('form.iAgree')) + "\n            "), _c('a', {
    attrs: {
      "href": _vm.conditionsUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('form.conditions', {
    merchant: _vm.merchantName
  })) + "\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "vanguard-required-star"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span')]), _vm._v(" "), (_vm.errors.has('localConditionsApproved')) ? _c('div', {
    staticClass: "row vanguard-cgu vanguard-form-error",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first('localConditionsApproved')) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "vanguard-optins-container"
  }, [_c('div', {
    staticClass: "row form-group form-check vanguard-cgs"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCgsApproved),
      expression: "localCgsApproved"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "cgsApproved",
      "data-vv-name": "localCgsApproved"
    },
    domProps: {
      "checked": Array.isArray(_vm.localCgsApproved) ? _vm._i(_vm.localCgsApproved, null) > -1 : (_vm.localCgsApproved)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.localCgsApproved,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.localCgsApproved = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.localCgsApproved = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.localCgsApproved = $$c
        }
      }
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('form.iAgree')) + "\n            "), _c('a', {
    attrs: {
      "href": _vm.cgsUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('form.serviceConditions')))]), _vm._v(" "), _c('span', {
    staticClass: "vanguard-required-star"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span')]), _vm._v(" "), (_vm.errors.has('localCgsApproved')) ? _c('div', {
    staticClass: "row vanguard-cgs vanguard-form-error",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.errors.first('localCgsApproved')) + "\n        ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88f0ef6e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/multiple/components/contact-form.vue
// module id = 982
// module chunks = 0